import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const logClientActivity = async (clientId, data = {}) => {
  try {
    if (!clientId) return;
    const payload = {
      summary: data.summary || 'Actualización',
      detail: data.detail || '',
      entityType: data.entityType || 'general',
      action: data.action || 'update',
      referenceId: data.referenceId || null,
      metadata: data.metadata || null,
      createdBy: data.createdBy || null,
      createdAt: serverTimestamp(),
    };
    await addDoc(collection(db, 'clients', clientId, 'timeline'), payload);
  } catch (err) {
    console.warn('⚠️ No se pudo registrar actividad del cliente:', err.message);
  }
};

export default logClientActivity;
